import Button from "@mui/material/Button";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { DiagnosticsGrid } from "./components/DiagnosticsGrid";
import { DiagnosticAddinData } from "./models/DiagnosticAddinData";
import combineDiagnosticsData from "./utils/combineDiagnosticsData";
import SearchField from "@/components/filter/SearchField";
import { FilterStackLayout } from "@/components/layout/FilterStackLayout";
import AddInIds from "@/constants/AddInIds";
import { useAddinData } from "@/hooks/addins/useAddinData";
import { useDiagnosticsBySearch } from "@/hooks/diagnostic/useDiagnosticsBySearch";
import { useDebounced } from "@/hooks/useDebounced";

export default function DiagnosticEditPage() {
  const [search, setSearch] = useState("");
  const searchDebounced = useDebounced(search, 300);
  const { data: addinData = [] } = useAddinData<DiagnosticAddinData>(AddInIds.diagnosticData);
  const { data: diagnosticData = [], isLoading: isDiagnosticsLoading } =
    useDiagnosticsBySearch(searchDebounced);

  const data = combineDiagnosticsData(addinData, diagnosticData);

  const { t } = useTranslation();

  return (
    <FilterStackLayout
      filters={
        <>
          <SearchField
            value={search}
            setValue={setSearch}
            title={t("diagnosticEdit.title")}
            placeholder={t("diagnosticEdit.inptPlaceholder")}
          />
          <Button
            size="small"
            sx={{ height: 40 }}
            variant="outlined"
            onClick={() => setSearch("**Unknown Diagnostic")}
          >
            {t("diagnosticEdit.unknownFilter", "Filter unknown Diagnostics")}
          </Button>
        </>
      }
      content={<DiagnosticsGrid isLoading={isDiagnosticsLoading} data={data} />}
    />
  );
}
